<template>
	<div class="container-tree">
		<div class="search-container">
			<!-- <app-tooltip-button
				:icon="allExpande ? 'remove_circle_outline' : 'add_circle_outline'"
				:text="allExpande ? 'Contraer' : 'Expandir'"
				:size="18"
				color="white"
				@click-icon="toogleTree"
			/> -->
			<div class="search-input">
				<input
					type="text"
					v-model="search"
					@keyup.enter="searchRows"
					@keyup.esc="searchRows"
				>
				<v-icon>search</v-icon>
			</div>
		</div>
		<div class="tree-table-grid theader" style="background-color: #02979b;">
			<span class="column-title" style="color: white;">Nombre</span>
			<span class="column-title" style="color: white;">Código</span>
			<span class="column-title" style="color: white;">Cuenta</span>
			<span class="column-title" style="color: white;">Stat</span>
			<span class="column-title" style="color: white;">Acciones</span>
		</div>
		<TreeNodesDl ref="tree" class="tree-node" children="children" text="name" :indent="20" :nodes="treeDataFilter.length > 0 ? treeDataFilter : treeData">
			<template slot-scope="{ node, isOpen }">
				<div class="tree-table-grid tbody" style="color: gray;">
					<div class="tree-title">
						<app-tooltip-button
							v-if="node.children.length > 0"
							:icon="isOpen ? 'remove_circle_outline' : 'add_circle_outline'"
							text="Agregar"
							:size="16"
							color="success"
						/>
						<span :class="{'childrens': !validateAccountFather(node)}">{{ node.name }}</span>
					</div>
					<span class="tool-code" :class="{'childrens': !validateAccountFather(node)}">
						{{ node.code }}
					</span>
					<span class="tool-type" :class="{'childrens': !validateAccountFather(node)}">
						{{ node.account }}
					</span>
					<div class="check-stat" @click.stop>
						<input
							v-if="!validateAccountFather(node)"
							type="checkbox"
							v-model="node.stat"
							@change.stop="$emit('chage-stat', node, $event)" />
					</div>
					<div class="tool-action">
						<app-tooltip-button
							v-if="validateAccountFather(node)"
							color="success"
							icon="add_circle_outline"
							text="Agregar"
							:size="16"
							:disabled="disabledButtons"
							@click-icon.stop="addItem($event, node, isOpen)"
						/>
						<app-tooltip-button
							color="success"
							icon="edit"
							text="Editar"
							:size="16"
							@click-icon.stop="editItem($event, node, isOpen)"
						/>
						<app-tooltip-button
							img="/static/img/actions-list/delete.svg"
							text="Eliminar"
							:width="16"
							:disabled="disabledButtons"
							@click-icon.stop="deleteItem($event, node, isOpen)"
						/>
					</div>
				</div>
			</template>
		</TreeNodesDl>
	</div>
</template>

<script>
import TreeNodesDl from 'tree-nodes-dl';
import appTooltipButton from '@/components/shared/app-tooltip-button';

function addItem(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	this.$emit('click-icon', 'add', node);
}

function editItem(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	this.$emit('click-icon', 'edit', node);
}

function deleteItem(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	this.$emit('click-icon', 'delete', node);
}

function searchRows() {
	if (!this.search) {
		this.treeDataFilter = [];
		this.$emit('update');
	} else {
		this.treeDataFilter = this.filterNodes(this.treeData, this.search);
	}
}

function filterNodes(nodes, searchQuery) {
	return nodes.map((node) => {
		const children = node.children ? this.filterNodes(node.children, searchQuery) : [];
		if (node.name.toLowerCase().includes(searchQuery.toLowerCase())
			|| node.code.toLowerCase().includes(searchQuery.toLowerCase())
			|| node.account.toLowerCase().includes(searchQuery.toLowerCase())
			|| children.length) {
			return { ...node, children };
		}
		return null;
	}).filter(node => node !== null);
}

// function toogleTree() {
// 	this.allExpande = !this.allExpande;
// 	this.toogleNodes(this.treeData, this.allExpande);
// }

// function toogleNodes(nodes, expand) {
// 	nodes.forEach((node) => {
// 		this.$set(node, 'isOpen', expand);
// 		if (node.children && node.children.length > 0) {
// 			this.toogleNodes(node.children, expand);
// 		}
// 	});
// }

function validateAccountFather(node) {
	const endPoint = node.account.endsWith('.');
	return node.flagParent === 1 || endPoint;
}

function disabledButtons() {
	const userI = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	const notFranchise = userI && (userI.company.franchise === null || userI.company.franchise === 0);
	const fatherFranchise = userI && userI.company
		&& userI.company.franchise
		&& userI.subsidiary.father
		? userI.company.franchise === 1 && userI.subsidiary.father === 1 : false;
	console.log('🙈 ~ disabledButtons ~ fatherFranchise:', fatherFranchise);
	return !notFranchise && !fatherFranchise;
}

function data() {
	return {
		search: null,
		treeDataFilter: [],
		allExpande: true,
	};
}

export default {
	name: 'tree-accounting-accounts',
	data,
	components: {
		TreeNodesDl,
		appTooltipButton,
	},
	methods: {
		addItem,
		editItem,
		deleteItem,
		searchRows,
		filterNodes,
		// toogleTree,
		// toogleNodes,
		validateAccountFather,
	},
	computed: {
		disabledButtons,
	},
	props: {
		treeData: {
			type: Array,
			default: [],
		},
	},
};
</script>

<style lang="scss" scoped>

.container-tree {
	padding: 10px 50px;
}
.theader {
	padding: 5px 0;
}

.tree-table-grid {
	align-items: center;
	display: grid;
	grid-template-columns: 1fr 120px 150px 50px 110px;

	.column-title {
		font-family: font(lato-bold);
		font-size: size(small);
		text-align: center;
	}

	.tree-title {
		align-items: center;
		display: flex;
	}
}

.tree-node { 
	.tbody {
		padding-left: 0px;
		font-size: size(small10);
	}
	.tool-code {
		border-left: 1px solid   #02979b;
		padding: 10px 5px;
		text-align: start;
	}

	.tool-type {
		border-left: 1px solid   #02979b;
		border-right: 1px solid   #02979b;
		padding: 10px 5px;
		text-align: start;
	}

	.check-stat{
		border-right: 1px solid   #02979b;
		padding: 10px 5px;
		text-align: start;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tool-action {
		align-items: center;
		display: flex;
		justify-content: center;
	}

	.tool-action {
		align-items: center;
		display: flex;
		justify-content: space-evenly;
	}
}
.childrens {
	color: color(secondary) !important;
	font-weight: bold;
}

.search-container {
	display: flex;
	align-items: center;
	justify-content: end;
	background-color: #02979b;
	padding: 5px;
	width: 100%;
}
.search-input {
	border: 1px solid color(grey-icon) !important;
	background-color: color(grey);
	border-radius: 15px !important;
	display: inline-flex;
	height: 23px;
	max-width: 170px;
	vertical-align: middle;
	width: 100%;

	input {
		color: color(black);
		outline: none;
		padding: 0 10px;
		font-size: size(small11);
		width: calc(100% - 25px);
	}

	.v-icon {
		align-self: center;
		color: color(grey-icon) !important;
		font-size: 20px;
		transform: rotate(90deg);
	}

	@media (max-width: 768px) {
		display: none;
		&.unique-input {
			width: 50px;
		}
	}
}

</style>


// WEBPACK FOOTER //
// src/components/accounting-accounts/tree-accounting-accounts.vue